export default __webpack_public_path__ + "static/media/checkmark.41705a5c.svg";